/**
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.operate.WELCOME_CODE+'/' + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.operate.WELCOME_CODE, METHOD.POST, result);
	},

}

export default {dataApi}